import { CreatePropertyAdV2 } from '../PropertyAdEditor';
import { Dashboard } from './Dashboard';

export const CreatePropertyAdV2Page = () => (
  <Dashboard openLogIn>
    <CreatePropertyAdV2 />
  </Dashboard>
);
